import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-802",
  "use": "icon-802-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-802\" viewBox=\"0 0 16 16\" id=\"icon-802\">\n  <path d=\"M8 0a8.031 8.031 0 0 0-1.065.079 7.992 7.992 0 0 0-.354 15.788h.001A7.952 7.952 0 0 0 8 16 8 8 0 0 0 8 0zm0 15.5a6.836 6.836 0 0 1-.725-.04A24.01 24.01 0 0 0 8.5 7.5 25.697 25.697 0 0 0 7.593.514C7.734.504 7.868.5 8 .5a7.5 7.5 0 0 1 0 15z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol